// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cC_kW"};